import React, { Component } from 'react';
import { connect } from 'react-redux';

// Components
import SidePanel from '../../../../../../components/SidePanel';
import Icon from '../../../../../../components/Icon';
import NewNFForm from './NewNFForm';

// css
import './styles.css';
import { getPackagingTypes } from '../../../../../../redux/new-schedule';

class AddNFPanel extends Component {
  componentDidMount() {
    this.props.dispatch(getPackagingTypes());
  }
  _onSubmit = (values) => {
    this.props.onNewNF(values);
  }

  _onCancel = (e) => {
    e.preventDefault();
    this.props.onDismiss();
  }

  render() {
    return (
      <SidePanel onDismiss={this.props.onDismiss}>
        <div className="AddNFPanel">
          <div className="AddNFPanel__header">
            <Icon
              className="ScheduleDetail__close-modal"
              name="close"
              onClick={this.props.onDismiss}
            />
            <h3 className="AddNFPanel__header-title">Adicionar Nota Fiscal</h3>
          </div>

          <NewNFForm
            onSubmit={this._onSubmit}
            onCancel={this._onCancel}
            packagingTypes={this.props.packagingTypes}
          />
        </div>
      </SidePanel>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    packagingTypes: state.newSchedule.packagingTypes.list,
  }
}
export default connect(mapStateToProps)(AddNFPanel);
